import type { SchedulerVisiblePeriod } from '@cocoonspace/ui/components/cocoon/scheduler-calendar/types'
import { useMemo, useState } from 'react'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { SchedulerCalendar } from '@cocoonspace/ui/components/cocoon/scheduler-calendar'
import { useLingui } from '@lingui/react'

import { EventCard } from './event-card/event-card'
import { useAllEvents } from './my-events/use-all-events.hook'

export const MyEventsCalendar = () => {
	const { i18n } = useLingui()
	const locale = i18n.locale as 'fr' | 'en'

	const [visiblePeriod, setVisiblePeriod] =
		useState<SchedulerVisiblePeriod | null>(null)

	const { events: eventsData } = useAllEvents({
		from: dateTimeUtils(visiblePeriod?.start)
			.subtract(1, 'week')
			.format('YYYY-MM-DD'),
		to: dateTimeUtils(visiblePeriod?.end).add(1, 'week').format('YYYY-MM-DD'),
	})

	const events = useMemo(() => {
		return (
			eventsData?.map((event) => ({
				id: event.id,
				title: event.title ?? '',
				start: dateTimeUtils(event.startLocal).toDate(),
				end: dateTimeUtils(event.endLocal).toDate(),
				metadata: {
					...event,
					icon: event.location.type === 'remote' ? 'camera' : null,
				},
			})) ?? []
		)
	}, [eventsData])

	return (
		<SchedulerCalendar
			locale={locale}
			events={events}
			className='max-h-[600px]'
			onVisiblePeriodChange={setVisiblePeriod}
			renderSelectedEvent={({ event }) => (
				<EventCard
					event={event.metadata as never}
					className='max-w-[352px] !shadow-[inset_0_0_0_2px_#ff4338]'
				/>
			)}
		/>
	)
}
